// Site/SiteForm/RequiredFieldMarker.jsx
import React from "react";

const RequiredFieldMarker = () => (
  <span className="text-red-500 ml-1 dark:text-red-400" aria-label="required field">*</span>
);

export default RequiredFieldMarker;
